import React, { useState, useRef, useEffect } from "react";
import communication from "../assets/images/communication.svg";

interface AskquestionProps {
  onSendMessage: (message: string) => void;
  isLoading?: boolean;
}

export default function Askquestion({ onSendMessage, isLoading = false }: AskquestionProps) {
  const [message, setMessage] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim() && !isLoading) {
      onSendMessage(message.trim());
      setMessage("");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [message]);

  return (
    <form className="chat-input-wrapper" onSubmit={handleSubmit}>
      <textarea
        ref={textareaRef}
        className="chat-input-textarea"
        placeholder="Ask me anything..."
        rows={2}
        maxLength={8000}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyPress={handleKeyPress}
        disabled={isLoading}
      />

      <div className="chat-input-footer">
        <small className="text-muted">{message.length}/8000</small>
        <button
          type="submit"
          className="chat-input-send"
          disabled={!message.trim() || isLoading}
        >
          <img
            src={communication}
            alt="Send"
            className={`chat-send-icon ${(!message.trim() || isLoading) ? "disabled" : ""}`}
          />
        </button>
      </div>
    </form>
  );
}